/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import { DialogTitle } from "@radix-ui/react-dialog";
import { useCallback, useState } from "react";

import { numericPercentages, spacing } from "../../../../../../global/emotion";
import { Text } from "../../../../../components/_base/_core/Text/Text.emotion";
import type { CarouselApi } from "../../../../../hooks/useCarousel";
import { ModalCarousel } from "./ModalCarousel.emotion";
import type { RenderableItem } from "./PostPrayerModal.emotion";

const titleStyle: Interpolation = {
  left: numericPercentages[50],
  position: "absolute",
  textAlign: "center",
  top: 31,
  transform: "translateX(-50%)",
  width: spacing.full,
};
export const PostPrayerModalContent = ({
  items,
  carouselApi,
}: {
  items: RenderableItem[];
  carouselApi: CarouselApi;
}) => {
  const [title, setTitle] = useState<string>("");
  const analytics = useAnalytics();

  const handleVisibility = useCallback(
    (idx: number) => {
      setTitle(items[idx].title);
      analytics.track({
        event: HallowAnalyticsEvent.ViewedPostPrayerScreen,
        properties: { screen_name: items[idx].type },
      });
      analytics.postEvent({ event: `post-prayer-seen-${items[idx].id}` });
    },
    [items, analytics],
  );

  return (
    <>
      <DialogTitle asChild>
        <Text as={"h2"} type={"title"} size={"m"} css={titleStyle}>
          {title}
        </Text>
      </DialogTitle>
      <ModalCarousel onVisible={handleVisibility} carouselApi={carouselApi}>
        {items.map((obj) => obj.element)}
      </ModalCarousel>
    </>
  );
};
